import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import type { NonGenerativeAIAnswerResultShownProps } from './types';

// When the user clicks the view all "x" work items button
export const onJiraViewAllButtonClicked: ({
	searchSessionId,
	queryHash,
	brand,
	source,
	query,
	answerCardType,
	answerString,
}: NonGenerativeAIAnswerResultShownProps & {
	totalIssuesCount: number;
}) => AnalyticsEventPayload = ({
	searchSessionId,
	queryHash,
	brand,
	source,
	query,
	answerCardType,
	answerString,
}: NonGenerativeAIAnswerResultShownProps & {
	totalIssuesCount: number;
}): AnalyticsEventPayload => {
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerJiraCardViewAll',
		source,
		eventType: 'ui',
		attributes: {
			searchSessionId,
			queryHash,
			brand,
			source,
			answerCardType,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
